export default __webpack_public_path__ + "static/media/file-word.f31d9768.svg";